import React from 'react';
import { Upload, Button, message  } from 'antd';
import {
	PlusOutlined, UploadOutlined, InboxOutlined
} from '@ant-design/icons';
import {returnIframeUrl} from "../../../../lib/http";
import 'antd/dist/antd.css';
import './UploadComponent.scss'

class UploadComponent extends React.Component{
	constructor(props) {
		super(props);
		this.state = {
			defaultFileList: [],
			fileList: [],
		};
	}

	componentDidMount() {
		
	}
	
	UNSAFE_componentWillReceiveProps(props){
		let fileList = this.getDefaultFileList(props);
		this.setState((prev, props) => {
			return { fileList }
		})
	}

	getDefaultFileList = (props) => {
		const { fileList } = props;
		let temp = []
		if(fileList && fileList.length > 0){
			fileList.map(val => {
				temp.push({
					response: {file_id: val.file_id}, 
					name: val.name, 
					uid: val.file_id || val.uid, 
					status: 'done',
					// url: returnIframeUrl('/download_attachment/?file_id='+ val.file_id +'&download=1')
					Url:'#'
				})
			})
		}
		return temp
	}

	upload = (info) => {
		const { status } = info.file;
		if (status !== 'uploading') {
			console.log(info.file, info.fileList);
			let prosperity = []
			info.fileList.map((item,index) => {
				if( item.response.success !== 0){
					prosperity.push(item)
				}
			})
			this.setState((prev, props) => {
				return { fileList: prosperity }
			})

			if(info.file.response.success === 0){
                message.error(`${info.file.response.error}`);
                return
            }
		}
		// 点击移除文件时的同步数据
		if ( status == "removed" ){
			this.props.onChange(info);
		}
		if (status === 'done') {
			let response = info.file.response;
			if(response.success){
				message.success(`${info.file.name} 文件上传成功.`);
				if(this.props.onChange){
					this.props.onChange(info);
				}
			}
		} else if (status === 'error') {
			message.error(`${info.file.name} 文件上传失败.`);
		}
		
		this.setState((prev, props) => {
			return { fileList: info.fileList }
		})
		
	};

	render(){
		const { key, disabled } = this.props;
		const { fileList } = this.state
		return(
			<div className="UploadComponent">
			<Upload.Dragger
				name="file"
				multiple={true}
				// defaultFileList={defaultFileList}
				fileList={fileList}
				action={returnIframeUrl("/citic/fast_upload_attachment/")}
				onChange={(info) => this.upload(info)}
				disabled={disabled}
				progress={{
					strokeColor: {
						'0%': '#108ee9',
						'100%': '#87d068',
					},
					strokeWidth: 3,
					format: percent => `${parseFloat(percent.toFixed(2))}%`,
				}}
			>
				<p className="ant-upload-drag-icon">
					<InboxOutlined />
				</p>
				<div classNameant="ant-load-div">
					{/* <p className="ant-upload-text">点击或者拖拽文件到本区域上传</p> */}
					<p className="ant-upload-hint" id="ant-upload-hint" style={{lineHeight:'50px'}}>
						支持单文件或者多文件同时拖拽上传
					</p>
				</div>
				
			</Upload.Dragger>
			</div>
		)
	}
}

export default UploadComponent;


// WEBPACK FOOTER //
// app/components/customPage/investment-advisor/Pages/UploadComponent.jsx